/**
 * Product identity. These are proper nouns, so they are not part of the
 * translation dictionaries — they read the same in every language.
 */
export const BRAND_NAME = 'Globerce';
export const BRAND_PRODUCT = 'Globerce TMS';
